import { BaseModel, ModelInstance, ToFrontHook, ToBackHook } from './util';


@ModelInstance({
  mappingFields: {
    id: 'id',
    players_count: 'playersCount',
    teams_count: 'teamsCount',
    games_count: 'gamesCount',
    paid_sum: 'paidSum',
    debt_sum: 'debtSum',
  },
})
export class OrganizationStatistic extends BaseModel {
  id: number;
  playersCount: number;
  teamsCount: number;
  gamesCount: number;
  paidSum: number;
  debtSum: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
